import {
  FETCH_CROSSCONNECT_UPLINK_TELEMETRY,
  FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_ERROR,
  FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_PENDING,
} from 'services/Telemetry/CrossConnect/types';

const INITIAL_STATE = {
  fetchCrossConnectUplinkTelemetryIsCompleted: false,
  fetchCrossConnectUplinkTelemetryIsPending: false,
  fetchCrossConnectUplinkTelemetryIsError: null,
};

const telemetryCrossConnectReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_CROSSCONNECT_UPLINK_TELEMETRY:
      return {
        ...state,
        fetchCrossConnectUplinkTelemetryIsCompleted: true,
        fetchCrossConnectUplinkTelemetryIsPending: false,
        fetchCrossConnectUplinkTelemetryIsError: null,
      };
    case FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_PENDING:
      return {
        ...state,
        fetchCrossConnectUplinkTelemetryIsCompleted: false,
        fetchCrossConnectUplinkTelemetryIsPending: true,
        fetchCrossConnectUplinkTelemetryIsError: null,
      };
    case FETCH_CROSSCONNECT_UPLINK_TELEMETRY_IS_ERROR:
      return {
        ...state,
        fetchCrossConnectUplinkTelemetryIsCompleted: true,
        fetchCrossConnectUplinkTelemetryIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchCrossConnectUplinkTelemetryIsError: action.error,
      };

    case 'RESET_CROSSCONNECT_TELEMETRY_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default telemetryCrossConnectReducer;
